module.exports = __webpack_public_path__ + "img/person-two.d30bb689.png";